import React, { useContext } from 'react';
import FieldGroup from "./FieldGroup";
import Field from "./Field";
import UploadField from "./UploadField";
import { GlobalContext } from "../context/GlobalProvider";

const GoodItem = ({ index }) => {
    const {
        state: { goods, errors },
        dispatch,
    } = useContext(GlobalContext);

    const { good, photos, description } = goods[index];

    const handleChange = (e, name) => {
        const value = e.target.value;
        const newData = goods;

        newData[index][name] = value
        dispatch({
            type: 'UPDATE_GOODS',
            payload: newData
        });
    }

    const handleFileChange = (e) => {
        const newData = goods;

        newData[index]['photos'] = e.target.files
        dispatch({
            type: 'UPDATE_GOODS',
            payload: newData
        });
    }

    const removeGoodItem = () => {
        dispatch({
            type: "REMOVE_GOOD",
            payload: index
        })
    }

    return (
        <>
            <div className="col-span-full flex gap-4 items-center mb-4">
                {index !== 0 ?
                    <button
                        type="button"
                        className="btn--black-small border border-white"
                        onClick={removeGoodItem}
                    >
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                            <path d="M3.80005 8L12.2025 8" stroke="currentColor" strokeLinecap="square"/>
                        </svg>
                    </button>
                    : null}
                <h6 className="text-white paragraph-1">Produkt #{index + 1}</h6>
            </div>

            <Field
                onChange={(e) => handleChange(e, 'good')}
                value={good}
                name="good[]"
                label="Produktname"
                required={true}
                error={errors['goods.' + index + '.good']}
            />

            <FieldGroup
                full={true}
                hasError={errors['goods.' + index + '.description']}
            >
                <div className="relative floating-label">
                    <textarea
                        name="description[]"
                        value={description}
                        onChange={(e) => handleChange(e, 'description')}
                        rows={5}
                        className="w-full bg-transparent border-b border-neutrals-700 text-white py-3 focus:outline-none focus:ring-0 focus:border-neutrals-400"
                        placeholder=" "
                    />
                    <label className="text-neutrals-400">Fehlerbeschreibung*</label>
                </div>
            </FieldGroup>

            <UploadField
                name={'files-' + index}
                onChange={(e) => handleFileChange(e)}
                value={photos}
                error={errors['goods.' + index + '.photos']}
            />
        </>
    );
};

export default GoodItem;
